import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api, getStoreUsername } from '../lib/api'
import { useCartStore } from '../stores/cartStore'
import PuckRenderer from '../components/PuckRenderer'
import ProductGrid from '../components/ProductGrid'
import CartButton from '../components/CartButton'
import LoadingSpinner from '../components/LoadingSpinner'
import Footer from '../components/Footer'

function StorePage() {
  const storeUsername = getStoreUsername()

  const { data: page, isLoading: pageLoading, error: pageError } = useQuery({
    queryKey: ['page', 'home'],
    queryFn: () => api.getPublishedPage('home'),
    retry: 1,
  })

  const { data: products = [], isLoading: productsLoading } = useQuery({
    queryKey: ['products'],
    queryFn: () => api.getProducts(),
    enabled: !!page, // Only fetch products if page exists
  })

  const { data: config } = useQuery({
    queryKey: ['store-config'],
    queryFn: () => api.getStoreConfig(),
    enabled: !!page, // Only fetch config if page exists
  })

  const setTaxRate = useCartStore((state) => state.setTaxRate)
  const setShippingCost = useCartStore((state) => state.setShippingCost)

  // Update cart with store configuration
  useEffect(() => {
    if (config) {
      setTaxRate(config.taxRate)
      setShippingCost(config.shippingCost)
    }
  }, [config, setTaxRate, setShippingCost])

  if (pageLoading) {
    return <LoadingSpinner />
  }

  // Handle store not found or not published
  if (pageError || !page) {
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-1 flex items-center justify-center bg-gray-50 px-4">
          <div className="max-w-md w-full text-center">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h1 className="text-2xl font-bold text-gray-900 mb-2">
                Toko Tidak Ditemukan
              </h1>
              <p className="text-gray-600 mb-6">
                Toko <span className="font-semibold">{storeUsername}</span> belum
                aktif atau tidak tersedia.
              </p>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-sm text-blue-800">
                  Jika Anda pemilik toko ini, silakan login ke dashboard dan
                  publikasikan halaman toko Anda.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }

  return (
    <div className="min-h-screen flex flex-col">
      <CartButton />

      {/* Render page content */}
      <div className="flex-1">
        <PuckRenderer data={page.grapesJsData} />

        <div className="container mx-auto px-4 py-8">
          <h2 className="text-2xl font-bold mb-6">Produk Kami</h2>
          {productsLoading ? (
            <div className="flex justify-center py-12">
              <LoadingSpinner />
            </div>
          ) : (
            <ProductGrid products={products} />
          )}
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default StorePage
